import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgInternalOnly = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect y={0.5} width={21} height={20} rx={3} fill="#E00546" />
      <path
        d="M6.47 14.5H4.984V6.547H6.47V14.5Zm9.42-3.976a4.43 4.43 0 0 1-.291 1.622 3.843 3.843 0 0 1-.82 1.287 3.743 3.743 0 0 1-1.27.853 4.32 4.32 0 0 1-1.645.302c-.6 0-1.15-.1-1.65-.302a3.803 3.803 0 0 1-1.276-.853 3.844 3.844 0 0 1-.819-1.287 4.43 4.43 0 0 1-.292-1.623c0-.582.098-1.121.292-1.617.194-.498.467-.929.82-1.292a3.736 3.736 0 0 1 1.275-.847 4.294 4.294 0 0 1 1.65-.308c.602 0 1.15.103 1.645.308.495.205.918.49 1.27.853.353.359.626.788.82 1.286.194.495.291 1.034.291 1.617Zm-1.518 0c0-.437-.058-.827-.175-1.172a2.45 2.45 0 0 0-.495-.886 2.138 2.138 0 0 0-.793-.555 2.695 2.695 0 0 0-1.045-.192c-.388 0-.738.064-1.05.192a2.188 2.188 0 0 0-.797.556 2.513 2.513 0 0 0-.501.885 3.625 3.625 0 0 0-.176 1.171c0 .437.059.83.176 1.178.117.344.284.637.5.88.22.238.486.421.798.55.312.128.662.192 1.05.192.39 0 .737-.064 1.045-.193.312-.128.576-.311.792-.55.217-.242.382-.535.495-.88.118-.348.177-.74.177-1.176Z"
        fill="#fff"
      />
    </svg>
  );
};
export default SvgInternalOnly;
